export default "__VITE_ASSET__37MDcgxE__"